import { searchDisplayMode, isPhone, isWeb } from '@helpers';
import { MachineGroup } from '@interfaces/machines';

export const getDisplayModeFlags = (displayMode: string | null) => ({
  isSmallMode: displayMode === searchDisplayMode.square,
  isBlockMode: displayMode === searchDisplayMode.block,
  isLineMode: displayMode === searchDisplayMode.line,
  isTileMode: displayMode === searchDisplayMode.infoTiles,
  isTableMode: displayMode === searchDisplayMode.tableStandard || displayMode === searchDisplayMode.tableCompact,
});

export const getMarginTop = (displayMode: string | null, IS_NARROW_WEB: boolean): number => {
  const { isBlockMode, isSmallMode, isLineMode, isTileMode } = getDisplayModeFlags(displayMode);

  if (isBlockMode) {
    return isPhone && !IS_NARROW_WEB ? -23 : !isWeb ? -21 : IS_NARROW_WEB ? -2 : 0;
  }

  if (isSmallMode) {
    return isPhone && !IS_NARROW_WEB ? -6 : !isWeb || IS_NARROW_WEB ? -3 : 0;
  }

  if (isLineMode) {
    return isPhone && !IS_NARROW_WEB ? -12 : !isWeb ? -8 : 0;
  }

  if (isTileMode) {
    return isPhone && !IS_NARROW_WEB ? -18 : !isWeb ? -15 : IS_NARROW_WEB ? 18 : -4;
  }

  if (displayMode === searchDisplayMode.tableStandard) {
    return !IS_NARROW_WEB ? -10 : -13;
  }

  return 0;
};

export const getODataBySelectedGroup = (selectedGroup: MachineGroup | null): string | null => {
  if (!selectedGroup) return null;
  return 'MachineId eq ' + selectedGroup.machines?.map((m) => m.machineId)?.join(' or MachineId eq ');
};

export const isCloseToBottom = (nativeEvent: {
  layoutMeasurement: { height: number };
  contentOffset: { y: number };
  contentSize: { height: number };
}): boolean => {
  return nativeEvent.layoutMeasurement.height + nativeEvent.contentOffset.y >= nativeEvent.contentSize.height - 500;
};

export const getTopValue = (displayMode: string | null, IS_NARROW_WEB: boolean): number => {
  return displayMode === searchDisplayMode.infoTiles ? 10 : isPhone && !IS_NARROW_WEB ? 15 : 100;
};
